import { Injectable } from '@angular/core';
import { domain } from '../variables/domain';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomMenuService {
  constructor(private http: HttpClient) { }

  AddCustomMenu(data:any) {
    return this.http
      .post(domain.AddCustomMenu, data, { responseType: 'text' })
      .pipe(
        map((res: string) => {
          try {
            return JSON.parse(res);
          } catch {
            return res;
          }
        })
      );
  }

  GetCustomMenuList(UserId:any, Type:any) {
    return this.http
      .get(domain.GetCustomMenuList + UserId + "&Type=" + Type, { responseType: 'text' })
      .pipe(
        map((res: string) => {
          try {
            return JSON.parse(res);
          } catch {
            return res;
          }
        })
      );
  }

  DeleteCustomMenu(Id:any) {
    return this.http
      .post(domain.DeleteCustomMenu + Id, {}, { responseType: 'text' })
      .pipe(
       map((res: string) => {
          try {
            return JSON.parse(res);
          } catch {
            return res;
          }
        })
      );
    }

    
  GetHowToUseAppList() {
    return this.http
      .get(domain.GetHowToUseAppList, { responseType: 'text' })
      .pipe(
        map((res: string) => {
          try {
            return JSON.parse(res);
          } catch {
            return res;
          }
        })
      );
  }

}
